import TextCell from '../cells/text';

export const entityBaseBodyRender =
  // eslint-disable-next-line react/display-name
  (showId?: boolean) => (value: EntityBase | null | undefined) => {
    return (
      <>
        {' '}
        {value ? (
          <TextCell
            value={(showId ? `[${value.id}] ` : '') + value.name}
            textAlign="left"
          />
        ) : (
          <></>
        )}
      </>
    );
  };
